module.exports = __webpack_public_path__ + "static/vpe-777f16e4230a70a82ed48238cd865e66.svg";